import {
  updateSurvey
} from '@/api/survey'

var saveMixins = {
  inject: ['reload'],
  computed: {
    // 获取到路由中的id，编辑状态 url 有id，创建状态则没有
    id: {
      get: function () {
        return this.$route.params.id
      },
      set: function () {}
    }
  },
  methods: {
    // 保存问卷
    save(status) {
      let surveyBody = JSON.parse(JSON.stringify(this.surveyBody))
      surveyBody.status = status
      // 如果是更新问卷
      if (this.id) {
        updateSurvey(this.id, surveyBody).then(() => {
          this.$message({
            type: 'success',
            center: true,
            message: `问卷${status === 'published' ? '发布' : '保存'}成功`,
            duration: 1500
          })
          this._complete(status)
        }).catch(err => {
          this.$message({
            type: 'error',
            center: true,
            message: err.response.data.message,
            duration: 1500
          })
        })
      }
    },

    // 保存完成
    _complete(status) {
      if (status === 'published' || status === 'stay') {
        const router = this.surveyBody.type === 'online' ? '/collect/link/' :
          '/task/person/'
        this.$router.push({
          path: `${router}${this.id}`
        })
        this.$store.dispatch('getSurvey', this.id)
      } else {
        this.$router.push({
          name: 'list'
        })
      }
      // 成功创建或者修改后，
      // 需要将 Vuex 中的 surveyBody 重置成为空 SurveyBody
      this.$store.dispatch('setEmptySurveyBody')
    }
  }
}

export default saveMixins